module.exports = __webpack_public_path__ + "static/media/down-arrow.5a60d5e4.svg";